import { isEmpty } from 'lodash';

import {
    REQUEST_ACCOUNT_GODCHILDREN,
    RECEIVE_ACCOUNT_GODCHILDREN,
    FAILURE_ACCOUNT_GODCHILDREN
} from './constants';
import { CALL_API } from '../../../middlewares/api';

const shouldFetchAccountGodchildren = state => {
    const godchildren = state.account.sponsorship.godchildren;
    const requests = state.account.sponsorship.requests;
    const fetching = state.account.sponsorship.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(godchildren) && isEmpty(requests)) {
        return true;
    } else {
        return false;
    }
};

export function fetchAccountGodchildrenIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/user/sponsorship',
            types: [
                REQUEST_ACCOUNT_GODCHILDREN,
                RECEIVE_ACCOUNT_GODCHILDREN,
                FAILURE_ACCOUNT_GODCHILDREN
            ],
            shouldCallAPI: state => shouldFetchAccountGodchildren(state),
            authenticated: true
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/godchildren/actions.js